<template>
    <vx-card title="Atendentes" subtitle="Tickets" collapse-action refresh-content-action :close="false" @refresh="loadReport" :download-card-action="table.show" @download="download">
        <div>
            <div class="vx-row" style="margin-bottom: 40px;">
                <div class="w-full flex justify-end">
                    <div class="mr-2">
                        <i-select placeholder="Relatado por" v-model="filters.users.selected" clearable @on-change="loadReport" class="w-64">
                            <Option v-for="item in filters.users.options" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </i-select>
                    </div>
                    <div class="mr-2">
                        <i-select placeholder="Tipo do ticket" v-model="filters.ticketTypes.selected" clearable @on-change="loadReport" class="w-64">
                            <Option v-for="item in filters.ticketTypes.options" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </i-select>
                    </div>
                    <div class="mr-2">
                        <InputNumber :active-change="false" :max="36" :min="1" v-model="filters.period" @on-change="loadReport"></InputNumber>
                    </div>
                    <div class="mr-2">
                        <i-switch @on-change="loadReport" false-value="mensal" size="large" class="m-2"
                                    true-value="semanal" v-model="filters.periodType.selected">
                            <span slot="open">SEM</span>
                            <span slot="close">MEN</span>
                        </i-switch>
                    </div>
                </div>
            </div>
            <Spin size="large" fix v-show="chart.loading"></Spin>
            <chart :options="chart" @click="getDetails"></chart>
            <TicketsTable :csv="this.table.download" :analistas="analistas" :relatores="time_apoio" :loading="table.loading"
                :tickets="table.data" v-show="table.show" :exibir-projeto="false" exibir-detalhes ocultar-finalizados></TicketsTable>
        </div>
    </vx-card>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import {mapActions, mapGetters} from "vuex";
export default {
    components: {
        chart: () => import("../../../components/charts/BarChart")
    },
    data () {
        return {
            filters: {
                users: {
                    options: [],
                    selected: 0
                },
                ticketTypes: {
                    options: [{value: 32, label: 'Bug'}, {value: 33, label: 'melhoria'}, {value: 35, label: 'Solicitação de Serviço'},
                        {value: 45, label: 'MVP'}],
                    selected: 0
                },
                period: 6,
                periodType: {
                    selected: 'semanal',
                    enum: {semanal: 'week', mensal: 'month'}
                }
            },
            chart: {
                legend: {
                    data: ["Bem descritos", "Mal descritos", "Total"]
                },
                loading: false,
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true,
                    show:false
                },
                xAxis: {
                    type: 'category',
                    data: [],
                    axisLine: {onZero: true},
                    splitLine: {show: false},
                    splitArea: {show: false},
                },
                yAxis: {
                    value: 'category'
                },
                tooltip: {
                    type: 'shadow',
                },
                series:[]
            },

            table: {
                columns: [{title: '#', key: 'id_ticket'}, {title: 'Relator', key: 'relatado_por_nome'},
                    {title: 'Data cadastro', key: 'data_hora_cadastro',render: (h, params) => {
                        return h('p', moment(params.row.cliente_desde).format('DD-MM-YYYY'))
                    }}],
                data: [],
                show: false,
                loading: false,
                download: false
            }
        }
    },

    computed: {
        ...mapGetters(['usuarios', 'analistas', 'time_apoio'])
    },
    methods: {
        download () {
            this.table.download = true;
            this.$nextTick(() => {
                this.table.download = false;
            })
        },

        loadChartXAxis ()
        {
            this.chart.xAxis.data = Array.from(Array(this.filters.period + 1), (i, index) => {
                if (this.filters.periodType.selected === 'semanal') {
                    return `${index + 1} ${this.filters.periodType.selected.substr(0, 3)}. atrás`
                }
                return moment().subtract(index, 'months').format("MMMM/YY");
            }).reverse();
        },

        loadReport: _.debounce(function () {
            this.chart.loading = true;
            this.getStats().then((data) => {
                this.buildSeriesChart(data);
                this.loadChartXAxis();
                this.chart.loading = false;
            });
        }, 250),

        buildSeriesChart(data)
        {
            const labelTop = {
                normal: {
                    position: 'top',
                    show: true,
                    formatter: (param) => param.value ? Math.abs(param.value) : '',
                }
            };
            this.chart.series = [
                {
                    name: 'Bem descritos',
                    type: 'bar',
                    color: '#228B22',
                    data: _.orderBy(data, ['period'], ['asc']).map(t => ({value:t.qtd_bem, period: t.period})),
                    label: labelTop
                },
                {
                    name: 'Mal descritos',
                    type: 'bar',
                    color: '#B22222',
                    data: _.orderBy(data, ['period'], ['asc']).map(t => ({value:t.qtd_mal, period: t.period})),
                    label: labelTop
                },
                {
                    name:'Total',
                    type:'line',
                    markLine:{
                        lineStyle:{
                            color:'#00FFFF'
                        }
                    },
                    label:{
                        normal:{
                            position:'top',
                            show:true
                        }
                    },
                    data: _.orderBy(data, ['period'], ['asc']).map(t => ({value:t.total, period: t.period}))
                }
            ]
        },

        async getDetails(data)
        {
            if (!data.selected) {
                this.table.loading = true;
                this.table.show = true;
            } else {
                this.table.show = false;
                return;
            }
            this.$axios('/ticket/estatisticas/atendentes/detalhe', {params: {
                periodo: this.filters.period, formato: this.filters.periodType.enum[this.filters.periodType.selected],
                relatado_por: this.filters.users.selected, tipo_ticket: this.filters.ticketTypes.selected,
                periodoSelecionado: data.data.period, malDescrito: data.seriesIndex
            }}).then(({data}) => {
                this.table.data = data;
                this.table.loading = false;
            })
        },

        async getStats ()
        {
            const {data} = await this.$axios(`/ticket/estatisticas/atendentes`, {params: {
                periodo: this.filters.period, formato: this.filters.periodType.enum[this.filters.periodType.selected],
                relatado_por: this.filters.users.selected, tipo_ticket: this.filters.ticketTypes.selected
            }});

            return data;
        },

        async loadUsers()
        {
            this.filters.users.options = this.usuarios.map(user => ({value: user.id_pessoa, label: user.nome}))
        }
    },

    created () {
        this.loadUsers();
        this.loadReport();
    }
}
</script>

<style scoped>

</style>